module.exports = __webpack_public_path__ + "img/3-1.54092784.png";